import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'

const SettingForm = props => {
  const methods = useForm({defaultValues: props.data || {}})
  const {errors} = methods.formState

  return (
    <Stack className='setting-form'>
      <FormWrapper methods={methods} handleSubmit={props.handleSubmit}>
        <Input
          error={!!errors.name}
          label='Name'
          name='name'
          options={{
            required: 'Name is required',
            pattern: {value: /^[A-Z][A-Z0-9_]*$/, message: 'Use uppercase letters, digits and underscores'}
          }}
          helperText={errors.name?.message || 'The name the code will read.'}
          margin='dense'
        />
        <Input
          error={!!errors.value}
          label='Value'
          name='value'
          options={{required: 'Value is required'}}
          helperText={errors.value?.message}
          margin='dense'
        />
        <Button
          disabled={props.loading}
          type='submit'
          variant='contained'
          sx={{color: '#F7F7F7'}}>
          Submit
        </Button>
      </FormWrapper>
    </Stack>
  )
}

export default SettingForm
